/**
 * stayai-no-decimals.js
 * Strips decimal portions from prices rendered by the Stay AI subscription widget.
 * Loaded as a deferred module so it never blocks page render.
 * Uses MutationObserver scoped to the widget container(s) to handle Stay AI's
 * async rendering and plan-selection re-renders.
 */

const WIDGET_SELECTOR = '.stayai-widget, .stayai-subscriptions, purchase-options';
const PRICE_RE = /(\$[\d,]+)\.\d+/g;

function stripDecimals(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const updated = node.nodeValue.replace(PRICE_RE, '$1');
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }
}

function processAll() {
  document.querySelectorAll(WIDGET_SELECTOR).forEach(stripDecimals);
}

function observeWidget(container) {
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      stripDecimals(container);
      pending = false;
    });
  }).observe(container, { childList: true, subtree: true, characterData: true });
}

function init() {
  const containers = document.querySelectorAll(WIDGET_SELECTOR);

  if (containers.length) {
    containers.forEach((c) => {
      stripDecimals(c);
      observeWidget(c);
    });
    return;
  }

  // Widget not yet in DOM — watch body until it appears, then hand off
  const bodyObs = new MutationObserver(() => {
    const found = document.querySelectorAll(WIDGET_SELECTOR);
    if (!found.length) return;
    bodyObs.disconnect();
    found.forEach((c) => {
      stripDecimals(c);
      observeWidget(c);
    });
  });
  bodyObs.observe(document.body, { childList: true, subtree: true });
}

init();
